import { dailyBlotterColumunsApiConnector, dailyBlotterQuotesApiConnector } from 'apiConnector/daily-blotter';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, debounceTime, map, mergeMap, take, withLatestFrom } from 'rxjs/operators';
import {
  dailyBlotterColumnsReceived,
  dailyBlotterColumnsRequestFailed,
  dailyBlotterQuotesReceived,
  dailyQuotesRequestFailed,
} from 'state/blotters/dailyBlotter/dailyBlotter.action';
import type {
  DailyBlotterColumns,
  DailyBlotterResponse,
  Filters,
} from 'state/blotters/dailyBlotter/dailyBlotter.model';
import type { EpicWithThunk } from 'state/state.common';

export interface FetchDailyBlotterQuotesEpicApi {
  fetchDailyBlotterQuotes: (
    pageIndex: number,
    filters: Filters,
    itemPerPage: number,
  ) => Observable<DailyBlotterResponse>;
}
export function fetchDailyBlotterQuotesEpic(): EpicWithThunk {
  return (action$, state$, { selectors: { getDailyBlotterQuotesInfo }, httpClient }) =>
    action$.pipe(
      ofType(
        'DAILY_BLOTTER_PAGE_CHANGED',
        'DAILY_BLOTTER_QUOTES_REQUESTED',
        'DAILY_BLOTTER_ITEMS_PER_PAGE_CHANGED',
        'DAILY_BLOTTER_FILTERS_UPDATED',
      ),
      debounceTime(500),
      withLatestFrom(state$),
      mergeMap(([, state]) => {
        const { page, size: itemsPerPage, filters } = getDailyBlotterQuotesInfo(state);
        return dailyBlotterQuotesApiConnector(httpClient)
          .fetchDailyBlotterQuotes(page, filters, itemsPerPage)
          .pipe(
            map(quotes => dailyBlotterQuotesReceived(quotes.entries, quotes.pageInfo)),
            catchError(_ => of(dailyQuotesRequestFailed())),
          );
      }),
    );
}

// COLUMNS DEF

export interface FetchDailyBlotterColumnsDefinitionEpicApi {
  fetchDailyBlotterColumns: () => Observable<DailyBlotterColumns>;
}

export function fetchDailyBlotterColumnsEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('DAILY_BLOTTER_COLUMNS_REQUESTED'),
      take(1),
      mergeMap(() => {
        return dailyBlotterColumunsApiConnector(httpClient)
          .fetchDailyBlotterColumns()
          .pipe(
            map(columnsDefinition => {
              return dailyBlotterColumnsReceived(columnsDefinition);
            }),
            catchError(_ => of(dailyBlotterColumnsRequestFailed())),
          );
      }),
    );
}
